<template>
  <div class="cdkey">
    <div>
      <h1>
        <span style="margin-right: 20px">CDkey批次列表</span>
        <el-button size="small" type="primary" @click="handleAdd"
          >添加CDkey批次</el-button
        >
      </h1>
    </div>
    <div>
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="price" label="价格"></el-table-column>
        <el-table-column prop="number" label="数量"></el-table-column>
        <el-table-column prop="number" label="类型">
          <template slot-scope="{ row }">
            <span v-if="row.special===0">普通CDK</span>
            <span v-if="row.special===1">特殊CDK</span>
            <span v-if="row.special===2">微信CDK</span>
            </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间"></el-table-column>
        <el-table-column prop="action" label="操作">
          <template slot-scope="{ row }">
            <el-button @click="pathToCdkey(row.id)">CDkeys</el-button>
            <el-button
              type="danger"
              @click="deleteCdkey(row.id)"
              >作废</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="visibleAdd" title="添加CDkey批次" width="400px">
      <el-form
        :model="formData"
        label-width="100px"
        :rules="rules"
        ref="addForm"
      >
        <el-form-item prop="name" label="批次名称">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item prop="price" label="面值">
          <el-input v-model="formData.price"></el-input>
        </el-form-item>
        <el-form-item prop="number" label="生成数量">
          <el-input v-model="formData.number"></el-input>
        </el-form-item>
        <el-form-item prop="special" label="cdk类型">
          <el-select v-model="formData.special" placeholder="否">
            <el-option :value="0" label="普通CDK"></el-option>
            <el-option :value="1" label="特殊CDK"></el-option>
            <el-option :value="2" label="微信CDK"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleAdd = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="addCDkey"
          :loading="buttonLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="dataMeta.current_page"
      @current-change="handlePageChange"
      v-if="dataMeta && dataMeta.total > dataMeta.per_page"
    ></el-pagination>
  </div>
</template>

<script>
import table from '../../mixins/table'
import {
  postData, patchData
} from '@/http'
export default {
  mixins: [table],
  data() {
    return {
      config: {
        getUrl: 'cdk',
        delUrl: 'cdk'
      },
      visibleAdd: false,
      buttonLoading: false,
      formData: {
        name: undefined,
        price: undefined,
        number: undefined,
        special: 0
      },
      rules: {
        name: [{
          required: true,
          message: '批次名称不能为空'
        }],
        price: [{
          required: true,
          message: '面值不能为空'
        }],
        number: [{
          required: true,
          message: '生成数量不能为空'
        }]
      }
    }
  },
  methods: {
    handleAdd() {
      this.visibleAdd = true
    },
    addCDkey() {
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          this.buttonLoading = true
          postData('cdk', this.formData)
            .then(res => {
              this.$message.success('添加成功')
              this.visibleAdd = false
              this.getTableData()
            })
            .finally(() => {
              this.buttonLoading = false
            })
        }
      })
    },
    // 查看cdk详情
    pathToCdkey(id) {
      let routeData = this.$router.resolve({
        path: `/cdkey/${id}`
      })
      window.open(routeData.href, '_blank')
    },
    //批量作废cdk
    deleteCdkey(id) {
      this.$confirm('确定要作废吗？', {
        type: 'warning'
      }).then(res => {
        patchData(`cdk_item_all/${id}`)
          .then(res => {
            this.$message.success('作废成功！')
          })
          .finally(() => {
          })
      })
    }
  }
}

</script>

<style>
</style>
